import { render, staticRenderFns } from "./ConfigurarDetalleForm.vue?vue&type=template&id=7538aa85&"
import script from "./ConfigurarDetalleForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarDetalleForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarDetalleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports